<div class="container">
  <textarea
    [(ngModel)]="message"
    rows="1"
    (ngModelChange)="autoGrow()"
    id="textarea"
    maxlength="2000"
    placeholder="مشکل یا نظر خود را بنویسید..."
  ></textarea>
</div>
